import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';

export function TruncatedText({ text, className }) {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [text]);

    return (
        <Tooltip title={isTruncated ? text : ''} placement="top" enterDelay={1000} leaveDelay={1} disableHoverListener={!isTruncated}>
            <Box
                ref={ref}
                className={className}
                style={{
                    display: 'block',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    cursor: isTruncated ? 'help' : 'default',
                }}
            >
                {text}
            </Box>
        </Tooltip>
    );
}

TruncatedText.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
};

TruncatedText.defaultProps = {
    text: '',
    className: undefined,
};
